module.exports = __webpack_public_path__ + "images/directory/icons/notCompliant.22ef3361a6b3b7ee50ed.svg";